import type { CSSProperties } from 'react';

import { PageTitles } from '@revelio/core';
import { Text } from '@revelio/ui';

import { LockIcon } from '../../shared/ui/icons';
import { ContactSalesButton } from './ContactSalesButton';
import styles from './data-unavailable-banner.module.css';

interface DataUnavailableBannerProps {
  style?: CSSProperties;
  featureUnavailable?: boolean;
}

function DataUnavailableBanner({
  style,
  featureUnavailable,
}: DataUnavailableBannerProps) {
  return (
    <div
      className={styles.container}
      style={style}
      data-testid="trial-user-data-unavailable-banner"
    >
      <div className={styles.banner}>
        <LockIcon width={15} height={17} />
        <Text fontSize="sm" weight="semibold" className={styles.message}>
          {`This ${featureUnavailable ? 'feature' : 'data'} is not available for trial users. Please contact sales to
          upgrade.`}
        </Text>
      </div>
      <ContactSalesButton
        page={PageTitles.TALENT_DISCOVERY}
        buttonProps={{ size: 'xs' }}
      />
    </div>
  );
}

export default DataUnavailableBanner;
